import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session'; // <-- sessionStorage
import loginReducer from '../Redux/Reducers/loginReducer';
import medicineReducer from '../Redux/Reducers/medicineReducer';
import patientReducer from '../Redux/Reducers/patientReducers';
import treatmentReducer from '../Redux/Reducers/treatmentReducer';
import doctorReducer from '../Redux/Reducers/doctorReducers';
import clinicReducer from '../Redux/Reducers/clinicReducer';
import receptionistReducer from '../Redux/Reducers/receptionistReducer';
import appointmentReducer from '../Redux/Reducers/appointmentReducer';
import prescriptionReducer from '../Redux/Reducers/prescriptionReducer';
import billingReducer from '../Redux/Reducers/billingReducer';
import dashboardReducer from '../Redux/Reducers/dashboardReducer';

const rootReducer = combineReducers({
    loginReducer,
    medicineReducer,
    patientReducer,
    treatmentReducer,
    doctorReducer,
    clinicReducer,
    receptionistReducer,
    appointmentReducer,
    prescriptionReducer,
    billingReducer,
    dashboardReducer,
});

const persistConfig = {
    key: 'root',
    storage: storageSession, // <-- use sessionStorage
    whitelist: [
        "loginReducer",
        "medicineReducer",
        "patientReducer",
        "treatmentReducer",
        "doctorReducer",
        "clinicReducer",
        "receptionistReducer",
        "appointmentReducer",
        "prescriptionReducer",
    ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);
export default store;
